import React, { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  CircularProgress,
  Box,
  Typography,
  TextField,
  MenuItem,
  Chip,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import {
  uploadAttachment,
  deleteAttachment,
} from "../services/AttachmentService/AttachmentService";
import AppConfig from "../config";

export default function AttachmentModal({
  open,
  handleClose,
  projectCode,
  setTagAttachments,
  tagAttachments,
  setFormValues,
  formValues,
  attachmentCategories,
}) {
  const [isFileLoading, setIsFileLoading] = useState(false);
  const [dragActive, setDragActive] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("");

  const handleDrop = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    setDragActive(false);
    const { files } = event.dataTransfer;
    await handleFileUpload(files);
  };

  const handleDrag = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (event.type === "dragenter" || event.type === "dragover") {
      setDragActive(true);
    } else if (event.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleFileUpload = async (files) => {
    if (files) {
      const filesArray = Array.from(files);
      const formData = new FormData();
      filesArray.forEach((file) => {
        formData.append("file", file);
      });

      try {
        setIsFileLoading(true);
        let iterableUploadFiles = [];
        let tagAttachmentTemp = [];

        const uploadedFiles = await uploadAttachment(formData, projectCode);

        if (uploadedFiles.message === "success") {
          let uploadedObj = {
            name: uploadedFiles.originalName,
            link: uploadedFiles.url,
            uniqueFileName: uploadedFiles.uniqueFileName,
          };

          const tagObject = {
            uniqueFileName: uploadedFiles.uniqueFileName,
            tags: [
              {
                key: "attachment_category_id",
                value: selectedCategory,
              },
            ],
          };
          tagAttachmentTemp.push(tagObject);
          setTagAttachments((prev) => [...prev, ...tagAttachmentTemp]);

          iterableUploadFiles.push(uploadedObj);
          setFormValues((prevValues) => ({
            ...prevValues,
            attachments: [
              ...(prevValues.attachments || []),
              ...iterableUploadFiles,
            ],
          }));
        }
      } catch (error) {
        console.error("Error uploading files:", error);
      } finally {
        setIsFileLoading(false);
      }
    }
  };

  const handleRemoveAttachment = async (index) => {
    const attachmentToDelete = formValues.attachments[index];
    try {
      let delResponse = await deleteAttachment(
        attachmentToDelete.uniqueFileName,
        projectCode
      );
      if (delResponse.message === "success") {
        setFormValues((prevValues) => ({
          ...prevValues,
          attachments: prevValues.attachments.filter((_, i) => i !== index),
        }));
        setTagAttachments((prevTagAttachments) =>
          prevTagAttachments.filter((_, i) => i !== index)
        );
      }
    } catch (err) {
      console.log("Error removing attachments:", err);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle>Upload Attachments</DialogTitle>
      <DialogContent>
        {isFileLoading ? (
          <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            <TextField
              select
              label="Category"
              fullWidth
              margin="normal"
              value={selectedCategory}
              onChange={(e) => setSelectedCategory(e.target.value)}
            >
              {attachmentCategories?.map((category, index) => (
                <MenuItem key={index} value={category.id}>
                  {category.category_name}
                </MenuItem>
              ))}
            </TextField>

            <div
              onDragEnter={handleDrag}
              onDragOver={handleDrag}
              onDragLeave={handleDrag}
              onDrop={handleDrop}
              style={{
                border: dragActive
                  ? "2px dashed #3f51b5"
                  : "2px dashed #c4c4c4",
                borderRadius: "8px",
                padding: "20px",
                textAlign: "center",
                position: "relative",
                cursor: "pointer",
              }}
              onClick={() => document.getElementById("fileInput").click()}
            >
              <CloudUploadIcon
                style={{
                  fontSize: "48px",
                  color: AppConfig.colorPalette.primary.main,
                }}
              />
              <Typography variant="h6">
                {dragActive
                  ? "Drop files here to upload"
                  : "Drag & Drop files or click to upload"}
              </Typography>
              <input
                type="file"
                multiple
                id="fileInput"
                onChange={(e) => handleFileUpload(e.target.files)}
                style={{
                  display: "none",
                }}
              />
            </div>

            <Box
              mt={2}
              display={"flex"}
              flexWrap={"wrap"}
              flexDirection={"row"}
            >
              {formValues.attachments &&
                formValues.attachments.map((attachment, index) => (
                  <Chip
                    key={index}
                    variant="outlined"
                    sx={{
                      marginRight: "10px",
                      backgroundColor: "#fdeded",
                      color: AppConfig.colorPalette.primary.main,
                      fontWeight: "700",
                      borderRadius: "4px",
                      border: "none",
                      "& .MuiChip-deleteIcon": {
                        backgroundColor: "transparent",
                        fontSize: "1.1rem",
                        "&:hover": {
                          borderRadius: "50%",
                          color: AppConfig.colorPalette.primary.main,
                          fontWeight: "bolder",
                        },
                      },
                    }}
                    label={attachment.name}
                    deleteIcon={<ClearIcon />}
                    // onClick={handleClick}
                    onDelete={() => handleRemoveAttachment(index)}
                  />
                ))}
            </Box>
          </>
        )}
      </DialogContent>
      <DialogActions>
        {/* <Button onClick={handleClose} color="secondary">
          Close
        </Button> */}
        <Button
          sx={{
            color: AppConfig.colorPalette.primary.main,
            "&:hover": {
              backgroundColor: AppConfig.colorPalette.primary.light,
            },
          }}
          //   onClick
          // startIcon={
          //   <CloudUploadIcon
          //     style={{ color: AppConfig.colorPalette.primary.main }}
          //   />
          // }
          onClick={handleClose}
        >
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
}
